import FaqSection from "@/components/sections/products/shared/faq";
import { PROXY_SERVER_FAQS } from "./faq-data";

export default function ProxyServerFaq() {
  return (
    <FaqSection
      faqs={PROXY_SERVER_FAQS}
      description="Quick answers to the most common questions about proxy servers, the types you'll come across, and which to pick for which job."
      headingId="proxy-server-faq-heading"
      headingClassName="scroll-mt-40"
      hideContactLink
    />
  );
}
